import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['item', 'form', 'resetForm', 'done' ]

  connect(){
    const total = this.itemTargets.length
    const answers = []
    let answered = 0

    this.itemTargets.forEach((item, index) => {
      item.addEventListener('traininganswered', (event) => {
        if (answers[index] === undefined) {
          answers[index] = item.dataset.answer
          answered ++
        }
        if (total === answered) {
          this.finish()
        }
      })
    })
  }

  finish() {
    this.formTarget.requestSubmit()
    this.element.dispatchEvent(new CustomEvent('exercisedone', { bubbles: true }))
    this.doneTarget.classList.remove('d-none')
    this.resetFormTarget.classList.remove('d-none')
    this.element.parentElement.dataset.done = 'true'
  }

  async reset(event) {
    // Prevent Turbo from handling the response (we're doing it manually)
    event.preventDefault()

    // Fire custom event before reset
    this.element.dispatchEvent(new CustomEvent('exercisereset', { bubbles: true }))
    
    let response
    
    // Turbo format: event.detail.fetchResponse.responseText is a Promise
    if (event.detail?.fetchResponse) {
      try {
        response = await event.detail.fetchResponse.responseText
      } catch (e) {
        console.error('Error extracting Turbo response:', e)
      }
    }
    
    if (response && typeof response === 'string' && response.trim().length > 0) {
      this.element.parentNode.innerHTML = response
      console.log('✓ Activity reset successful')
    } else {
      console.error('⚠️ Reset failed: No valid response', { detail: event.detail })
      alert('Failed to reset activity. Please refresh the page and try again.')
    }
  }
}
